import { createRoot } from 'react-dom/client';
import SentryService from './services/sentryService';
import App from 'App';
import './index.css';
import './styles/global-fonts.scss';
import { BrowserRouter } from 'react-router-dom';

// Initialize Sentry before React renders so early errors are captured
SentryService.getInstance().initialize();

createRoot(document.getElementById('root')!).render(
  // <StrictMode>
  <BrowserRouter>
    <App />
  </BrowserRouter>
  // </StrictMode>,
);
